import { AdministrationItemType } from "./data-structures";

export class ItemIdUtil {
  public static createItemId(id: number, type: AdministrationItemType, uniqueIdent: number): string {
    // JSON.stringify({id, type}) does not work with treeView
    return (id?.toString() ?? '') + '_' + type.toString() + '_' + (uniqueIdent?.toString() ?? '');
  }

  public static parseItemId(itemId: string): {id: number, type: AdministrationItemType} {
    const parts = itemId.split('_');
    return {id: parts[0] ? +parts[0] : null, type: +parts[1] };
  }
}
